import { render, staticRenderFns } from "./ComplaintAndSuggest.vue?vue&type=template&id=855bb26c&scoped=true&"
import script from "./ComplaintAndSuggest.vue?vue&type=script&lang=js&"
export * from "./ComplaintAndSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855bb26c",
  null
  
)

component.options.__file = "ComplaintAndSuggest.vue"
export default component.exports